import { render, staticRenderFns } from "./AtomTextAreaPrimary.vue?vue&type=template&id=4ca1e317&"
import script from "./AtomTextAreaPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomTextAreaPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports